export default "__VITE_ASSET__ivtiLQbE__"